import React, { FunctionComponent } from "react"
import { Line } from "react-chartjs-2"
import { ChartData, ChartOptions, DefaultDataPoint } from "chart.js"
import { vonmisesSample } from "@components/Distribution/VonmisesDistributionChart/vonmises.calc"

interface Props {
  loc: number
  scale: number
  kappa: number
  lbound?: number
  ubound?: number
}

export const VonmisesDistributionChart: FunctionComponent<Props> = ({
  loc = 0,
  scale = 0,
  kappa = 1,
  lbound = undefined,
  ubound = undefined,
}) => {
  const { data, labels } = vonmisesSample(kappa, loc, scale, lbound, ubound)

  const chartData: ChartData<"line", DefaultDataPoint<"line">, number> = {
    labels,
    datasets: [
      {
        data,
        fill: false, // Fill the area under the curve
        tension: 0.1,
      },
    ],
  }
  const chartOptions: ChartOptions<"line"> = {
    responsive: true,
    maintainAspectRatio: true,
    scales: {
      x: {
        type: "linear", // Use a linear scale for x-axis
        title: {
          display: true,
          text: "Value",
        },
      },
      y: {
        title: {
          display: true,
          text: "Probability Density",
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
    },
  }
  return <Line options={chartOptions} data={chartData}></Line>
}
